import * as React from "react";
import * as cn from "classnames";
import { connect, Dispatch } from "react-redux";
import { AppState } from "@store";

import "./ReviewInfoBlock.css";

export interface ReviewInfoBlockComponentProps {
    title: string;
    className?: "big-block" | "small-block";
    children: React.ReactChild | React.ReactChild[];
}

export interface ReviewInfoBlockComponentState {}

export class ReviewInfoBlockComponent extends React.Component<
    ReviewInfoBlockComponentProps,
    ReviewInfoBlockComponentState
> {
    constructor(props: ReviewInfoBlockComponentProps) {
        super(props);
    }

    render() {
        const { title, className, children } = this.props;
        return (
            <fieldset className={cn("info-block_wrapper", className)}>
                <legend className="info-block_title">{title}</legend>
                <div className="info-wrapper">{children}</div>
            </fieldset>
        );
    }
}

export interface ReviewInfoBlockProps {}

export const ReviewInfoBlock = connect(
    (state: AppState, ownProps: ReviewInfoBlockProps) => ({}),
    (dispatch: Dispatch, ownProps: ReviewInfoBlockProps) => ({})
)(ReviewInfoBlockComponent);
